import React, { useEffect, useState } from 'react';
import { Download, X, Share } from 'lucide-react';

const SKJULT_TIL_KEY = 'install_prompt_skjult_til';

const erMobil = () => /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
const erIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
const erStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

const InstallPrompt = () => {
  const [hendelse, setHendelse] = useState(null);
  const [vis, setVis] = useState(false);
  const [iosHjelp, setIosHjelp] = useState(false);

  useEffect(() => {
    if (erStandalone() || !erMobil()) return;
    const skjultTil = parseInt(localStorage.getItem(SKJULT_TIL_KEY) || '0', 10);
    if (Date.now() < skjultTil) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setHendelse(e);
      setVis(true);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);

    // iOS Safari støtter ikke beforeinstallprompt – vis manuell guide etter kort delay
    if (erIOS()) {
      const t = setTimeout(() => setVis(true), 2500);
      return () => { clearTimeout(t); window.removeEventListener('beforeinstallprompt', onPrompt); };
    }
    return () => window.removeEventListener('beforeinstallprompt', onPrompt);
  }, []);

  const installer = async () => {
    if (erIOS()) { setIosHjelp(true); return; }
    if (!hendelse) return;
    hendelse.prompt();
    try { await hendelse.userChoice; } catch {}
    setVis(false);
  };

  const utsett = () => {
    // Ikke spør igjen på 7 dager
    localStorage.setItem(SKJULT_TIL_KEY, String(Date.now() + 7 * 86400000));
    setVis(false);
  };

  if (!vis) return null;

  return (
    <div style={{
      position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 2000,
      background: 'var(--theme-bg-card, #1f2937)',
      color: 'var(--theme-text, #fff)',
      border: '1px solid var(--theme-border, #334155)',
      borderRadius: 12,
      boxShadow: '0 12px 32px rgba(0,0,0,.35)',
      padding: 14,
      maxWidth: 480, marginLeft: 'auto', marginRight: 'auto',
    }}>
      {!iosHjelp ? (
        <>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <img src="/logo_2.png" alt="REGNINO"
                 style={{ width: 44, height: 44, borderRadius: 10, flexShrink: 0,
                          background: '#fff', padding: 4, objectFit: 'contain' }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 2 }}>
                Installer REGNINO
              </div>
              <div style={{ fontSize: 12, opacity: 0.8 }}>
                Legg til på hjem-skjermen for raskere tilgang og bilag-skanning.
              </div>
            </div>
            <button onClick={utsett} aria-label="Lukk"
                    style={{ background: 'transparent', border: 'none',
                             color: 'inherit', opacity: 0.6, cursor: 'pointer', padding: 4 }}>
              <X size={18} />
            </button>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button onClick={utsett} className="btn-ghost"
                    style={{ flex: 1, height: 38, fontSize: 13 }}>
              Ikke nå
            </button>
            <button onClick={installer} className="btn-primary"
                    style={{ flex: 1, height: 38, fontSize: 13,
                             display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
              <Download size={14} /> Installer
            </button>
          </div>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <Share size={18} />
            <div style={{ fontSize: 14, fontWeight: 700 }}>Slik installerer du på iPhone</div>
            <button onClick={utsett} aria-label="Lukk"
                    style={{ marginLeft: 'auto', background: 'transparent',
                             border: 'none', color: 'inherit', opacity: 0.6, cursor: 'pointer' }}>
              <X size={18} />
            </button>
          </div>
          <ol style={{ margin: 0, paddingLeft: 20, fontSize: 13, lineHeight: 1.7 }}>
            <li>Trykk på <b>Del</b>-ikonet <Share size={12} style={{ verticalAlign: 'middle' }} /> nederst i Safari</li>
            <li>Bla ned og velg <b>«Legg til på Hjem-skjerm»</b></li>
            <li>Trykk <b>«Legg til»</b> øverst til høyre</li>
          </ol>
          <button onClick={utsett} className="btn-primary"
                  style={{ width: '100%', marginTop: 12, height: 38, fontSize: 13 }}>
            OK, skjønner
          </button>
        </>
      )}
    </div>
  );
};

export default InstallPrompt;
